import { Link } from 'react-router-dom'
import { useMemo } from 'react'
import { useCityContext } from '@contexts/LocationContext'
import { useAuth } from '@contexts/AuthContext'
import { getWhatsappLink } from '@config/contacts'
import packageJson from '../../../package.json' // Import package.json
import './Footer.css'

const Footer = () => {
  const { city, isUberlandia, isRibeirao } = useCityContext()
  const { isAuthenticated } = useAuth()
  const currentYear = new Date().getFullYear()

  const instagramUrl = useMemo(() => {
    if (isUberlandia) {
      return 'https://www.instagram.com/arqbncd/'
    }
    if (isRibeirao) {
      return 'https://www.instagram.com/arqbeirao/'
    }
    return 'https://www.instagram.com/arqbncd/' // Default to Uberlândia if no city or unknown
  }, [isUberlandia, isRibeirao])

  // NEW: Determine WhatsApp URL dynamically
  const whatsappUrl = useMemo(() => {
    if (city?.slug) {
      return getWhatsappLink(city.slug)
    }
    return getWhatsappLink('uberlandia') // Default if no city selected
  }, [city])

  return (
    <footer className="footer">
      <div className="footer__container container">
        <div className="footer__main">
          {/* Logo e descrição */}
          <div className="footer__brand">
            <Link to={`/${city?.slug || ''}`} className="footer__logo">
              <img
                src={city?.slug === 'ribeirao-preto' ? '/icon-rib.png' : '/icon-udi.png'}
                alt="Arqzin Ingressos"
                className="footer__logo-image"
              />
            </Link>
            <p className="footer__description">
              Uma experiência universitária, para universitários, por universitários.
            </p>
            <div className="footer__location">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <span>{city?.name || 'Uberlândia'}, {city?.state || 'MG'}</span>
            </div>
          </div>

          {/* Links */}
          <div className="footer__links">
            <div className="footer__column">
              <h4 className="footer__column-title">Navegação</h4>
              <nav className="footer__nav">
                <Link to={`/${city?.slug || ''}`}>Eventos</Link>
                <Link to={`/${city?.slug || ''}/sobre`}>Sobre</Link>
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">Contato</a>
              </nav>
            </div>

            <div className="footer__column">
              <h4 className="footer__column-title">Conta</h4>
              <nav className="footer__nav">
                {isAuthenticated ? (
                  <>
                    <Link to={`/${city?.slug || ''}/perfil`}>Perfil</Link>
                    <Link to={`/${city?.slug || ''}/carteira`}>Carteira</Link>
                  </>
                ) : (
                  <Link to={`/${city?.slug || ''}/login`}>Login</Link>
                )}
              </nav>
            </div>

            <div className="footer__column">
              <h4 className="footer__column-title">Legal</h4>
              <nav className="footer__nav">
                <Link to={`/${city?.slug || ''}/termos-de-uso`}>Termos de Uso</Link>
                <Link to={`/${city?.slug || ''}/politica-de-privacidade`}>Privacidade</Link>
                <Link to={`/${city?.slug || ''}/politica-de-reembolso`}>Política de Reembolso</Link>
              </nav>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="footer__bottom">
          <div className="footer__bottom-left">
            <p className="footer__copyright">
              © {currentYear} Arq Produções (35.302.161/0001-14)
            </p>
            <p className="footer__version">
              Versão {import.meta.env.VITE_APP_VERSION || "unknown"}
            </p>
          </div>

          <div className="footer__social">
            <a
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
